import { CircularProgress, Grid2 } from "@mui/material";

export default function SplashScreen() {

    return (
        <Grid2 container height={'100vh'} gap={2} flexDirection={'column'} justifyContent={'center'} alignItems={'center'} bgcolor={({ palette }) => palette.primary.light}>
            <Grid2>
                <img src="/sierra-logo.png" />
            </Grid2>
            <Grid2>
                <CircularProgress size={48} />
            </Grid2>
        </Grid2>
    )
}